import { motion, useMotionValue, useTransform } from "framer-motion";
import { useEffect, useState } from "react";

export default function VantaBackgroundWaves() {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const [windowSize, setWindowSize] = useState({ width: 1920, height: 1080 });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    const handleMouseMove = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
    };
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [mouseX, mouseY]);

  const gridX = useTransform(mouseX, [0, windowSize.width], [-20, 20]);
  const gridY = useTransform(mouseY, [0, windowSize.height], [-20, 20]);

  return (
    <div
      onMouseMove={(e) => {
        mouseX.set(e.clientX);
        mouseY.set(e.clientY);
      }}
      className="absolute w-full h-full inset-0 -z-50 overflow-hidden bg-neutral-50"
    >

      {/* خطوط شبکه با پارالاکس */}
      <motion.div
        style={{ x: gridX, y: gridY }}
        className="absolute inset-0 bg-[linear-gradient(to_right,#99999940_1px,transparent_1px),linear-gradient(to_bottom,#99999940_1px,transparent_1px)] bg-[size:24px_24px]"
      />

      {/* گرین */}
      <div className="absolute inset-0 pointer-events-none grain-bg opacity-80 mix-blend-overlay" />

      {/* نقاط نورانی */}
      {[...Array(20)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full bg-blue-500/40 blur-[80px]"
          initial={{
            x: Math.random() * 100 + "vw",
            y: Math.random() * 100 + "vh",
            width: Math.random() * 300 + 100 + "px",
            height: Math.random() * 300 + 100 + "px",
          }}
          animate={{
            x: [null, Math.random() * 100 + "vw"],
            y: [null, Math.random() * 100 + "vh"],
            opacity: [0.2, 0.9, 0.2],
          }}
          transition={{
            duration: Math.random() * 10 + 10,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          }}
        />
      ))}

      {/* دایره دنبال‌کننده موس */}
      <motion.div
        className="absolute rounded-full bg-blue-500/20 blur-3xl pointer-events-none"
        style={{
          width: "200px",
          height: "200px",
          x: useTransform(mouseX, (x) => x - 100),
          y: useTransform(mouseY, (y) => y - 100),
        }}
      />

      {/* گرادیان مرکزی */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,#3b076480_0,transparent_70%)]" />
    </div>
  );
}
